import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f13192dc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/client_view_mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13192dc')) {
      api.createRecord('f13192dc', component.options)
    } else {
      api.reload('f13192dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f13192dc&", function () {
      api.rerender('f13192dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register-page/index.vue"
export default component.exports